import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import userRouters from "./userRoutes";
import { find } from "lodash";
import { getToken, removeToken } from "@/utils/token";
import { getUserInfo, removeProviderType, removeUserInfo } from "@/utils/user";
import { CONST_NO_TOKEN_PAGE, CONST_VD_IMGPREFIX } from "@/config/constant";
import store from "@/store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import buildRouteByServerData from "@/router/buildRouteByServerData";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes
});

const LOGIN_PAGE_NAME = "/login";

const RWA_JOINT_LOGIN_PAGE_NAME = "/rwa/joint-login";

const HOME_PAGE_NAME = "/home";

const MOBILE_PREFIX = "m_";

let buildRoute = false;
router.beforeEach(async (to, from, next) => {
  if (buildRoute && to.matched.length <= 0) {
    // 首页未授权时，登录落到已授权且无需路径参数的页面。
    const landing =
      to.path === HOME_PAGE_NAME &&
      router
        .getRoutes()
        .find(
          route =>
            route.name &&
            !route.path.includes(":") &&
            Object.prototype.hasOwnProperty.call(route.meta, "permission")
        );
    if (landing) {
      next({ path: landing.path, replace: true });
      return;
    }
    next({ name: "notFound" });
    return;
  }
  document.getElementById("app").scrollTop = 0;
  const token = getToken();
  if (to.path === RWA_JOINT_LOGIN_PAGE_NAME) {
    token && (await fetchUserInfo());
    next();
    return;
  }
  let routerPath = to.path;
  do {
    // 没有token跳登录
    if (!token) {
      routerPath = LOGIN_PAGE_NAME;
    } else {
      // 有token的话改写router为有token的路由
      if (!buildRoute) {
        !getUserInfo() && (await fetchUserInfo());
        let platformInfo = await store.dispatch(
          "platformStore/getPlatformInfo",
          { platform: "cds" }
        );
        try {
          platformInfo = JSON.parse(platformInfo.value);
          CONST_VD_IMGPREFIX.prefixImgUrl = platformInfo.prefixImgUrl;
          CONST_VD_IMGPREFIX.env = platformInfo.env;
          CONST_VD_IMGPREFIX.showOriginMerchantNo =
            platformInfo.showOriginMerchantNo;
          // eslint-disable-next-line no-empty
        } catch (e) {}
        await store.dispatch("cs/carrierAllList", {});
        buildRoute = await buildRouteByServerData.buildRoute(router);
        if (buildRoute) {
          next(to);
          return;
        }
      }
      if (!buildRoute) {
        routerPath = "/notFound";
        break;
      }
      routerPath = goToPageWhenlogined(to, routerPath);
    }
    // eslint-disable-next-line no-constant-condition
  } while (false);

  if (routerPath == "/notFound") {
    const r = router.getRoutes().filter(route => {
      return route.name === "customerStockList";
    });
    if (r.length > 0) {
      routerPath = r[0].path;
    }
  }

  if (routerPath == null || routerPath.trim().length <= 0) {
    routerPath = "/home";
  }

  if (from.path != routerPath) {
    NProgress.start();
  }

  const [path] = routerPath.split("?");
  if (path === to.path) {
    next();
  } else {
    next({ path: routerPath, query: to.query });
  }
});

router.afterEach(() => {
  NProgress.done();
});

// 判断当前路由是否是用户不可进入的路由
const checkUserRouterPermission = route => {
  const userInfo = getUserInfo();
  const userId = userInfo.userId;
  if (userId) {
    const userRouterConfig = find(userRouters, { userId });
    if (userRouterConfig) {
      return !userRouterConfig.disableRouter.includes(route.name);
    }
  }
  return true;
};

// 判断用户设备
const isMobile = () => {
  var u = navigator.userAgent;
  return !!u.match(/AppleWebKit.*Mobile.*/);
};

// 转换官网调整路径
const getToPath = name => {
  const routerName = name.split("_");
  const len = routerName.length;
  if (isMobile()) {
    return MOBILE_PREFIX + routerName[len - 1];
  } else {
    return routerName[len - 1];
  }
};

const fetchProviderType = async (successCallback, failCallback) => {
  try {
    await store.dispatch("queryProviderCopType");
    successCallback();
  } catch (e) {
    removeProviderType();
    removeToken();
    failCallback();
  }
};

// 是否需要token的页面
function redirectWithoutToken(to, router) {
  if (CONST_NO_TOKEN_PAGE.indexOf(to.name) !== -1) {
    return getToPath(to.name);
  }
  return router;
}

function redirectToLoginWithoutToken() {
  return getToPath(LOGIN_PAGE_NAME);
}

async function fetchUserInfo() {
  try {
    await store.dispatch("getUserInfo");
  } catch (e) {
    removeToken();
    removeUserInfo();
  }
}

const goToPageWhenlogined = (to, router) => {
  return router === LOGIN_PAGE_NAME ? HOME_PAGE_NAME : router;
};

export default router;
